import * as React from 'react';
import styled from 'styled-components';
import { PartnerContent } from 'packages/smart-home-support/partner';
import BREAK_POINTS from '../../styling/media-queries';
import { useScrollResetter } from 'packages/smart-home-support/hooks';
import VerizonTerms from './VerizonTerms';

const mobileMargins: string = '30px 15px';
const mobileBigMargins: string = '30px 30px';
const tabletMargins: string = '30px 60px';
const desktopMargins: string = '60px 90px';

const PdfLink = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: -1;
`;

const TermsContainer = styled.div`
  color: #1b1b1b;
  max-width: 1080px;
  margin: ${mobileMargins};

  @media ${BREAK_POINTS.mobileBig} {
    margin: ${mobileBigMargins};
  }

  @media ${BREAK_POINTS.tablet} {
    margin: ${tabletMargins};
  }

  @media ${BREAK_POINTS.desktop} {
    margin: ${desktopMargins};
  }
`;

const TermsHeader = styled.div`
  padding: 30px 0px 40px 0px;
  font-style: normal;
  font-weight: bold;
  line-height: 44px;
  font-size: 44px;
  letter-spacing: -0.3px;
  text-align: center;

  @media ${BREAK_POINTS.desktop} {
    font-size: 54px;
    padding: 30px 0px 60px 0px;
  }
`;

const TermsPage: React.SFC = () => {
  useScrollResetter();

  return (
    <Container>
      <TermsContainer>
        <TermsHeader>Terms &amp; Conditions</TermsHeader>
        <PartnerContent
          Asurion={
            <PdfLink>
              <a href={require('./pdf/Home+_Terms&Conditions_TOS_0609.pdf')} target="_blank">
                Home+ by Asurion Terms and Conditions
              </a>
            </PdfLink>
          }
          Sprint={
            <>
              <PdfLink>
                <a href={require('./pdf/SprintCompleteMyHome_T&Cs.pdf')} target="_blank">
                  Sprint Complete MyHome Terms and Conditions
                </a>
              </PdfLink>
              <PdfLink>
                <a href={require('./pdf/SprintCompleteMyHome_SPANISH.pdf')} target="_blank">
                  Sprint Complete MyHome TÉRMINOS Y CONDICIONES
                </a>
              </PdfLink>
              <PdfLink>
                <a href={require('./pdf/SprintCompleteMyHome_TOS.pdf')} target="_blank">
                  Tech Expert Terms of Service
                </a>
              </PdfLink>
            </>
          }
          TechCoachHome={
            <>
              <PdfLink>
                <a href={require('./pdf/VZPH_W_Terms_and_Conditions.pdf')} target="_blank">
                  Verizon Protect Home Terms and Conditions
                </a>
              </PdfLink>
              <PdfLink>
                <a href={require('./pdf/VZPH_Fios_Terms_and_Conditions.pdf')} target="_blank">
                  Verizon Protect Home (Fios) Terms and Conditions
                </a>
              </PdfLink>
              <PdfLink>
                <a href={require('./pdf/VZPH_W_Terms_of_Service.pdf')} target="_blank">
                  Verizon Protect Home Terms of Service
                </a>
              </PdfLink>
              <PdfLink>
                <a href={require('./pdf/VZPH_Fios_Terms_of_Service.pdf')} target="_blank">
                  Verizon Protect Home (Fios) Terms of Service
                </a>
              </PdfLink>
              <PdfLink>
                <a href={require('./pdf/VHDP_AWS_539_CL_(03.13.2020)-(Wireless)_(FINAL)_PDF.pdf')} target="_blank">
                  Verizon Home Device Protect Terms and Conditions (effective 7/22/21)
                </a>
              </PdfLink>
              <PdfLink>
                <a href={require('./pdf/VHDP_AWS_539_CL_(03.13.2020)-(FIOs)_(FINAL)_PDF.pdf')} target="_blank">
                  Verizon Home Device Protect (Fios) Terms and Conditions (effective 7/22/21)
                </a>
              </PdfLink>
              <PdfLink>
                <a href={require('./pdf/VHDP_Technical_TOS_(Wireless)_(001).pdf')} target="_blank">
                  Verizon Home Device Protect Terms of Service (effective 7/22/21)
                </a>
              </PdfLink>
              <PdfLink>
                <a href={require('./pdf/VHDP_Technical_TOS_(FIOs)_(002).pdf')} target="_blank">
                  Verizon Home Device Protect (Fios) Terms of Service (effective 7/22/21)
                </a>
              </PdfLink>
            </>
          }
          Verizon={<VerizonTerms />}
        />
      </TermsContainer>
    </Container>
  );
};

export default TermsPage;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/termspage/index.tsx